import useStableCallback from "src/hooks/useCallbackUtils/useStableCallback";
export default function useImg2TxtConverter(quill) {
    const convert = useStableCallback(async () => {
        const img2TextConverter = quill?.getModule('img2TxtConverter');
        img2TextConverter?.selectLocalImage();
    });
    return {
        convert,
    };
}
